export default __webpack_public_path__ + "static/media/jordan_7.c4da3238.png";